<script lang="ts">
	
	import {onMount} from "svelte";
    import {idPageServices, idPageAmenagements} from "../scripts/router2";
    import { storeIsIntro, storeDomain } from "../scripts/store";
	import { storeCurRoute } from "../scripts/router1";

	let isFlow51 = false;
	let isFlow52 = false;
	let start = false;

	function startIntro() {
		start = true;
	}

	onMount(async () => {
	});

	function goToAmenagements(timeout: number) {
		isFlow52 = true;
		setTimeout(() => {
			storeIsIntro.set(false);
			storeDomain.set(idPageAmenagements);
			storeCurRoute.set(idPageAmenagements);
		}, timeout)
	}

	function goToServices(timeout) {
		isFlow51 = true;
		setTimeout(() => {
			storeIsIntro.set(false);
			storeDomain.set(idPageServices);
			storeCurRoute.set(idPageServices);
		}, timeout)
	}

</script>

<style lang="scss">

	.introMobile {
		position: absolute;
		top: 0;
		left: 0;
		display: grid;
		grid-template-areas: "services amenagements";
		width: 100%;
		height: 100%;
		overflow: hidden;
		background-color: $color-bleu-instit;
		&__flow32 {
			background-color: $color-bordeau-instit;
		}

		.services {
			grid-area: services;
			z-index: 200;
			position: absolute;
			width: 100%;
			height: 100%;
			transform: skewX(-23deg);
			left: -50vw;
			padding: 0 0 0 50vw;
			overflow: hidden;
			&__rotation {
				transform: skewX(23deg);
				width: 210%;
				height: 100%;
				&__bg {
					opacity: 0;
					height: 100%;
					background-repeat: no-repeat;
					background-position: center;
					background-size: cover;
					transform: translate(0px, -2vw);
					background-image: url("../images/intro/intro-services.png");
					padding: 0 7vw 7vw 0;
					&__flow2 {
						animation: fade-in;
						animation-duration: 2s;
						animation-delay: 2s;
						animation-fill-mode: forwards;
					}
				}
			}
			&__flow3 {
				animation-name: fade-out;
				animation-duration: 1s;
				animation-delay: 0s;
				animation-fill-mode: forwards;
			}
		}
		.amenagements {
			grid-area: amenagements;
			z-index: 100;
			position: absolute;
			overflow: hidden;
			width: 100%;
			height: 100%;
			padding: 0 50vw 0 0;
			max-height: 0px;
			overflow: hidden;
			transform: translateX(-50vw);
			&__rotation {
				width: 200%;
				height: 100%;
				&__bg {
					opacity: 0;
					width: 100%;
					height: 100%;
					background-repeat: no-repeat;
					background-position: center;
					background-size: cover;
					background-image: url("../images/intro/intro-amenagements.png");
					&__flow2 {
						animation: fade-in;
						animation-duration: 2s;
						animation-delay: 2s;
						animation-fill-mode: forwards;
					}
				}
			}
			&__flow1 {
				animation-name: flow-12-mobile;
				animation-duration: 2s;
				animation-delay: 0s;
				animation-fill-mode: forwards;
			}
			&__flow3 {
				animation-name: fade-out;
				animation-duration: 1s;
				animation-delay: 0s;
				animation-fill-mode: forwards;
			}
		}

		.logo {
			z-index: 10000;
			position: absolute;
			top: 50%; left: 50%;
  			transform: translate(-50%, -50%);
			width: 100%;
			height: 9vw;
			background-repeat: no-repeat;
			background-position: center;
			background-size: contain;
			&__bleu {
				background-image: url("../images/intro/logo-bleu-mobile.png");
				opacity: 1;
				&__flow1 {
					animation-name: fade-out;
					animation-duration: 2s;
					animation-delay: 2s;
					animation-fill-mode: forwards;
				}
			}
			&__bleuorange {
				background-image: url("../images/intro/logo-mobile.png");
				opacity: 0;
				&__flow1 {
					animation-name: fade-in;
					animation-duration: 2s;
					animation-delay: 2s;
					animation-fill-mode: forwards;
				}
				&__flow3 {
					opacity: 1;
					animation-name: fade-out;
					animation-duration: 2s;
					animation-delay: 0s;
					animation-fill-mode: forwards;
				}
			}
		}
	}

	.button {
		transition: all;
		transition-duration: 1s;
		position: absolute;
		width: 70%;
		height: 40px;
		background-repeat: no-repeat;
		background-position: center;
		background-size: contain;
		z-index: 10000;
		opacity: 0;
		cursor: pointer;
		&__services {
			top: 30px;
			left: -22px;
			background-image: url("../images/intro/bouton-services-mobile.png");
		}
		&__amenagements {
			bottom: 30px;
			right: 0px;
			background-image: url("../images/intro/bouton-amenagements-mobile.png");
		}
		&__flow2 {
			animation-name: fade-in;
			animation-duration: 2s;
			animation-delay: 2s;
			animation-fill-mode: forwards;
		}
		&__flow3 {
			opacity: 1;
			animation-name: fade-out;
			animation-duration: 1s;
			animation-delay: 0s;
			animation-fill-mode: forwards;
		}
	}

	@keyframes flow-12-mobile {
		from {
			left: 0vw;
			max-height: Opx;
		}
		to {
			left: 0vw;
			max-height: 1000px;
		}
    }

	.introDesktop {
		display: none;
	}

	@include large {

		$flow1-duration: 3s;
		$flow1-delay: 0s;
		$flow2-duration: 1s;
		$flow2-delay: 2s;
		$flow3-duration: 2s;
		$flow3-delay: 3s;
		$flow4-duration: 2s;
		$flow4-delay: 4s;
		$flow5-duration: 2s;

		.introMobile {
			display: none;
		}

		.button {
			animation-delay: 7s;
			width: 30%;
			&__services {
				left: 0px;
				&:hover {
					background-image: url("../images/intro/bouton-services-hover.png");
				}
			}
			&__amenagements {
				right: 30px;
				&:hover {
					background-image: url("../images/intro/bouton-amenagements-hover.png");
				}
			}
			&__flow4 {
				animation-name: fade-in;
				animation-duration: $flow4-duration;
				animation-delay: $flow4-delay;
				animation-fill-mode: forwards;
			}
			&__flow5 {
				opacity: 1;
				animation-name: fade-out;
				animation-duration: $flow5-duration;
				animation-delay: 0s;
				animation-fill-mode: forwards;
			}
		}

		.introDesktop {
			position: absolute;
			top: 0;
			left: 0;
			cursor: pointer;
			display: grid;
			grid-template-areas: "services amenagements";
			grid-template-columns: 50% 50%;
			width: 100%;
			height: 100%;
			overflow: hidden;
			background-color: $color-bleu-instit;
			&__started {
				cursor: default;
			}
			&__flow52 {
				background-color: $color-bordeau-instit;
			}
		}
		.services {
			z-index: 100;
			display: grid;
			grid-area: services;
			position: absolute;
			left: -30%;
			top: 0px;
			background-color: $color-bleu-instit;
			width: 130%;
			height: 100%;
			transform: skewX(-23deg);
			overflow: hidden;
			&__flow51 {
				animation-name: flow-51;
				animation-duration: $flow5-duration;
				animation-fill-mode: forwards;
			}
			&__flow52 {
				transition: transform;
				transition-duration: $flow5-duration;
				transform: translateX(-3000px);
			}
		}
		.ammenagements {
			z-index: 100;
			display: grid;
			grid-area: amenagements;
			position: absolute;
			overflow: hidden;
			top: -100vh;
			left: 75vw;
			max-height: 0px;
			background-color: $color_bordeau_instit;
			width: 130%;
			height: 100%;
			max-height: 3000px;
			transform: skewX(-23deg);
			&__flow1 {
				animation-name: flow1;
				animation-delay: -2s;
				animation-duration: $flow1-duration;
				animation-fill-mode: forwards;
			}
			&__flow51 {
				transition: transform;
				transition-duration: $flow5-duration;
				transform: translateX(3000px);
			}
			&__flow52 {
				animation-name: flow-52;
				animation-duration: $flow5-duration;
				animation-delay: 0s;
				animation-fill-mode: forwards;
			}
		}
		.logo {
			z-index: 10000;
			position: absolute;
			top: 0;
			bottom: 0;
			left: 7px;
			right: 0;
			margin: auto;
			width: 100%;
			height: 200px;
			background-repeat: no-repeat;
			background-position: center;
			&__bleu {
				background-image: url("../images/intro/logo-bleu.png");
				opacity: 1;
				&__flow5 {
					opacity: 1;
					animation: none;
				}
			}
			&__orange {
				background-image: url("../images/intro/logo-orange.png");
				opacity: 0;
				&__flow5 {
					opacity: 1;
					animation: none;
				}
			}
			&__bleuorange {
				background-image: url("../images/intro/logo-bleu-orange.png");
				opacity: 0;
				&__flow1 {
					animation-name: fade-in;
					animation-duration: 0.5s;
					animation-delay: calc($flow1-delay + 0.5s);
					animation-fill-mode: forwards;
				}
				&__flow5 {
					opacity: 0;
					animation: none;
				}
			}
		}

		.strip {
			width: 100%;
			opacity: 0.5;
			&__img {
				width: 200%;
				height: 100%;
			}
			&__bleufromleft {
				z-index: 110;
				transform: translateX(-200vw);
				&__flow2 {
					animation-name: strip-left-services;
					animation-duration: $flow2-duration;
					animation-delay: $flow2-delay;
					animation-fill-mode: forwards;
				}
			}
			&__bleufromright {
				z-index: 110;
				transform: translateX(100vw);
				&__flow2 {
					animation-name: strip-right-services;
					animation-duration: $flow2-duration;
					animation-delay: $flow2-delay;
					animation-fill-mode: forwards;				
				}
			}
			&__orangefromright {
				z-index: 110;
				transform: translateX(-200vw);
				&__flow2 {
					animation-name: strip-left-amenagements;
					animation-duration: $flow2-duration;
					animation-delay: $flow2-delay;
					animation-fill-mode: forwards;
				}
			}
			&__orangefromleft {
				z-index: 210;
				transform: translateX(100vw);
				&__flow2 {
					animation-name: strip-right-amenagements;
					animation-duration: $flow2-duration;
					animation-delay: $flow2-delay;
					animation-fill-mode: forwards;				
				}
			}
			&__flow52 {
				transition: all;
				transition-duration: 1s;
				transform: translateX(0);
				opacity: 0;
			}
		}

		.tractoSimple {
			z-index: 5000;
			position: absolute;
			height: auto;
			width : 100%;
			top: 50%;
			left: 95%;
			transform: translate(-50%, -50%);
			opacity: 0;
			&__flow3 {
				animation-name: fade-in;
				animation-duration: $flow3-duration;
				animation-delay: $flow3-delay;
				animation-fill-mode: forwards;
			}
			&__img {
				width: 100%;
				height: 100%;
			}
			&__flow51 {
				opacity: 0;
				animation-duration: 0s;
				animation-delay: 0s;
			}
		}

		.tractoEllipse {
			z-index: 6000;
			position: absolute;
			height: auto;
			width : 100%;
			top: 50%;
			left: 95%;
			transform: translate(-50%, -50%);
			opacity: 0;
			&__flow4 {
				animation-name: fade-in;
				animation-duration: $flow4-duration;
				animation-delay: $flow4-delay;
				animation-fill-mode: forwards;
			}
			&__img {
				width: 100%;
				height: 100%;
			}
			&__flow51 {
				transform: translate(-105%, -50%);
			}
		}

		.compacteuseSimple {
			z-index: 5000;
			position: absolute;
			height: auto;
			width : 100%;
			top: 50%;
			left: 5%;
			transform: translate(-50%, -50%);
			opacity: 0;
			&__flow3 {
				animation-name: fade-in;
				animation-duration: $flow3-duration;
				animation-delay: $flow3-delay;
				animation-fill-mode: forwards;
			}
			&__img {
				width: 100%;
				height: 100%;
			}
			&__flow52 {
				opacity: 0;
				animation-duration: 0s;
				animation-delay: 0s;
			}
		}

		.compacteuseEllipse {
			z-index: 6000;
			position: absolute;
			height: auto;
			width : 100%;
			top: 50%;
			left: 5%;
			transform: translate(-50%, -50%);
			opacity: 0;
			&__flow4 {
				animation-name: fade-in;
				animation-duration: $flow4-duration;
				animation-delay: $flow4-delay;
				animation-fill-mode: forwards;
			}
			&__img {
				width: 100%;
				height: 100%;
			}
			&__flow52 {
				transform: translate(5%, -50%);
			}
		}
		.rotation {
			transform: skew(23deg);
			display: grid;
			grid-template-rows: 14.3%;
		}
	}

    @keyframes flow1 {
		0% {
			top: -100vh;
			left: 75vw;
			max-height: 0px;
		}
		50% {
			top: -100vh;
			left: 75vw;
			max-height: 0px;
		}
		100% {
			top: 0vh;
			left: 0vw;
			max-height: 3000px;
		}
    }

	@keyframes fade-out {
		from {
			opacity: 1;
		}
		to {
			opacity: 0;
		}
    }


    @keyframes fade-in {
		from {
			opacity: 0;
		}
		to {
			opacity: 1;
		}
    }

    @keyframes fade-in-out {
		0% {
			opacity: 0;
		}
		50% {
			opacity: 1;
		}
		100% {
			opacity: 0;
		}
    }

	@keyframes strip-left-services {
		from {
			transform: translateX(-200vw);
		}
		to {
			transform: translateX(-3vw);
		}
    }

    @keyframes strip-right-services {
		from {
			transform: translateX(100vw);
		}
		to {
			transform: translateX(-3vw);
		}
    }

	@keyframes strip-left-amenagements {
		from {
			transform: translateX(-200vw);
		}
		to {
			transform: translateX(-52vw);
		}
    }

    @keyframes strip-right-amenagements {
		from {
			transform: translateX(100vw);
		}
		to {
			transform: translateX(-52vw);
		}
    }

    @keyframes flow-51 {
		0% {
			opacity: 1;
			transform: skewX(-23deg);
		}
		50% {
			opacity: 1;
			transform: skewX(-23deg) translateX(50vw);
		}
		100% {
			opacity: 0;
			transform: skewX(-23deg) translateX(50vw);
		}
    }

    @keyframes flow-52 {
		0% {
			top: 0vh;
			left: 0vw;
			max-height: 3000px;
			width: 132%;
			transform: skewX(-23deg);
			opacity: 1;
		}
		50% {
			top: 0vh;
			left: 0vw;
			max-height: 3000px;
			width: 130%;
			transform: skewX(-23deg) translateX(-50vw);
			opacity: 1;
		}
		100% {
			top: 0vh;
			left: 0vw;
			max-height: 3000px;
			width: 130%;
			transform: skewX(-23deg) translateX(-50vw);
			opacity: 0;
		}
    }

</style>

<div class="introMobile" class:introMobile__flow32={isFlow52}>
	<div class="button button__services" class:button__flow2={!isFlow51 && !isFlow52} class:button__flow3={isFlow51 || isFlow52} on:click={() => goToServices(1000)} on:keydown={() => goToServices(1000)}></div>
	<div class="button button__amenagements" class:button__flow2={!isFlow51 && !isFlow52} class:button__flow3={isFlow51 || isFlow52} on:click={() => goToAmenagements(1000)} on:keydown={() => goToAmenagements(1000)}></div>
	<div class="services" class:services__flow3={isFlow51 || isFlow52}>
		<div class="services__rotation">
			<div class="services__rotation__bg services__rotation__bg__flow2">
				&nbsp;
			</div>
		</div>
	</div>
	<div class="logo logo__bleu logo__bleu__flow1">&nbsp;</div>
	<div class="logo logo__bleuorange logo__bleuorange__flow1" class:logo__bleuorange__flow3={isFlow51 || isFlow52}>&nbsp;</div>
	<div class="amenagements amenagements__flow1" class:amenagements__flow3={isFlow51 || isFlow52}>
		<div class="amenagements__rotation">
			<div class="amenagements__rotation__bg amenagements__rotation__bg__flow2">
				&nbsp;
			</div>
			</div>
	</div>
</div>
<div class="introDesktop" class:introDesktop__started={start} class:introDesktop__flow52={start && isFlow52} on:keydown={() => startIntro()} on:click={() => startIntro()}>
	<div class="logo logo__bleu" class:logo__bleu__flow5={isFlow51}></div>
	<div class="logo logo__bleuorange" class:logo__bleuorange__flow1={start} class:logo__bleuorange__flow5={start && (isFlow51 || isFlow52)}></div>
	<div class="logo logo__orange" class:logo__orange__flow5={start && isFlow52}>&nbsp;</div>
	<div class="button button__services" class:button__flow4={start && !isFlow51 && !isFlow52} class:button__flow5={start && (isFlow51 || isFlow52)} on:click={() => goToServices(2000)} on:keydown={() => goToServices(2000)}></div>
	<div class="button button__amenagements" class:button__flow4={start && !isFlow51 && !isFlow52} class:button__flow5={start && (isFlow51 || isFlow52)} on:click={() => goToAmenagements(2000)} on:keydown={() => goToAmenagements(2000)}></div>
	<div class="services" class:services__flow51={start && isFlow51}  class:services__flow52={start && isFlow52}>
		<div class="rotation">
		<div class="strip strip__bleufromleft" class:strip__bleufromleft__flow2={start} class:strip__flow52={start && isFlow51}>
			<img class="strip__img" src="../images/intro/ligne-bleue-1.png" alt="attal services">
		</div>
		<div class="strip strip__bleufromright" class:strip__bleufromright__flow2={start} class:strip__flow52={start && isFlow51}>
			<img class="strip__img" src="../images/intro/ligne-bleue-2.png" alt="attal services">
		</div>
		<div class="strip strip__bleufromleft" class:strip__bleufromleft__flow2={start} class:strip__flow52={start && isFlow51}>
			<img class="strip__img" src="../images/intro/ligne-bleue-3.png" alt="attal services">
		</div>
		<div class="strip strip__bleufromright" class:strip__bleufromright__flow2={start} class:strip__flow52={start && isFlow51}>
			<img class="strip__img" src="../images/intro/ligne-bleue-4.png" alt="attal services">
		</div>
		<div class="strip strip__bleufromleft" class:strip__bleufromleft__flow2={start} class:strip__flow52={start && isFlow51}>
			<img class="strip__img" src="../images/intro/ligne-bleue-3.png" alt="attal services">
		</div>
		<div class="strip strip__bleufromright" class:strip__bleufromright__flow2={start} class:strip__flow52={start && isFlow51}>
			<img class="strip__img" src="../images/intro/ligne-bleue-2.png" alt="attal services">
		</div>
		<div class="strip strip__bleufromleft" class:strip__bleufromleft__flow2={start} class:strip__flow52={start && isFlow51}>
			<img class="strip__img" src="../images/intro/ligne-bleue-1.png" alt="attal services">
		</div>	
		<div class="tractoSimple" class:tractoSimple__flow3={start && !isFlow51} class:tractoSimple__flow51={start && isFlow51}>
			<img class="tractoSimple__img" src="../images/intro/tracto-simple.png" alt="attal">
		</div>
		<div class="tractoEllipse" class:tractoEllipse__flow4={start} class:tractoEllipse__flow51={start && isFlow51}>
			<img class="tractoEllipse__img" src="../images/intro/tracto-ellipse.png" alt="attal">
		</div>
	</div>
	</div>
	<div class="ammenagements" class:ammenagements__flow1={start} class:ammenagements__flow51={start && isFlow51} class:ammenagements__flow52={start && isFlow52}>
		<div class="rotation">
		<div class="strip strip__orangefromleft" class:strip__orangefromleft__flow2={start && !isFlow52} class:strip__flow52={start && isFlow52}>
			<img class="strip__img" src="../images/intro/ligne-orange-1.png" alt="attal amenagements">
		</div>
		<div class="strip strip__orangefromright" class:strip__orangefromright__flow2={start && !isFlow52} class:strip__flow52={start && isFlow52}>
			<img class="strip__img" src="../images/intro/ligne-orange-2.png" alt="attal amenagements">
		</div>
		<div class="strip strip__orangefromleft" class:strip__orangefromleft__flow2={start && !isFlow52} class:strip__flow52={start && isFlow52}>
			<img class="strip__img" src="../images/intro/ligne-orange-3.png" alt="attal amenagements">
		</div>
		<div class="strip strip__orangefromright" class:strip__orangefromright__flow2={start && !isFlow52} class:strip__flow52={start && isFlow52}>
			<img class="strip__img" src="../images/intro/ligne-orange-4.png" alt="attal amenagements">
		</div>
		<div class="strip strip__orangefromleft" class:strip__orangefromleft__flow2={start && !isFlow52} class:strip__flow52={start && isFlow52}>
			<img class="strip__img" src="../images/intro/ligne-orange-3.png" alt="attal amenagements">
		</div>
		<div class="strip strip__orangefromright" class:strip__orangefromright__flow2={start && !isFlow52} class:strip__flow52={start && isFlow52}>
			<img class="strip__img" src="../images/intro/ligne-orange-2.png" alt="attal amenagements">
		</div>
		<div class="strip strip__orangefromleft" class:strip__orangefromleft__flow2={start && !isFlow52} class:strip__flow52={start && isFlow52}>
			<img class="strip__img" src="../images/intro/ligne-orange-1.png" alt="attal amenagements">
		</div>
		<div class="compacteuseSimple" class:compacteuseSimple__flow3={start && !isFlow52} class:compacteuseSimple__flow52={start && isFlow52}>
			<img class="compacteuseSimple__img" src="../images/intro/compacteuse-simple.png" alt="attal">
		</div>
		<div class="compacteuseEllipse" class:compacteuseEllipse__flow4={start} class:compacteuseEllipse__flow52={start && isFlow52}>
			<img class="compacteuseEllipse__img" src="../images/intro/compacteuse-ellipse.png" alt="attal">
		</div>
	</div>
	</div>
</div>
